import React, { useContext } from "react";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OrderCreateInvoiceView from "./OrderCreateInvoiceView/OrderCreateInvoiceView";
import "./OrderCreateInvoice.scss";
import OwPrintButton from "../../shared/OwPrintButton/OwPrintButton";
import { OrderTotalsPanel } from "../../order_entry/OrderTotalsPanel/OrderTotalsPanel";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import { OwViewOptionsPanel } from "../../shared/OwViewOptionsPanel/OwViewOptionsPanel";
import { useInvoiceViewOptions } from "../../../hooks/invoice/useInvoiceViewOptions";
import { useInvoiceViewOptionsUI } from "../../../hooks/invoice/useInvoiceViewOptionsUI";
import SupplierService from "../../../services/SupplierService";
import { useBulkDocumentOrders } from "../../../hooks/orders/useBulkDocumentOrders";
import { FormattedMessage } from "react-intl";

type Props = {
    /**
     * @deprecated
     */
    toggleMenu: () => void;
};

/**
 * Prints one Invoice per order, each on its own page, so a batch can be produced in one go. The
 * orders come from the query string: `?orders=a,b,c` from the Orders screen, or every order on the
 * daily routes in `?dailyRoutes=x,y` from the Daily Routes screen. The breadcrumbs lead back to
 * whichever screen the view was opened from.
 */
export const OrderCreateInvoice = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const supplierSettings = SupplierService.getSupplierSettings(supplierModel);
    const [viewOptions, handleViewOptionChange] = useInvoiceViewOptions(supplierSettings);
    const optionsPanelViewOptions = useInvoiceViewOptionsUI(viewOptions);

    const { orders, loaded, navItems } = useBulkDocumentOrders("Invoice");

    if (!supplierModel || !userModel) {
        return null;
    }

    return (
        <div className="OrderCreateInvoice col-12 mt-2 pb-5">
            <OwViewOptionsPanel viewOptions={optionsPanelViewOptions} onChangeFn={handleViewOptionChange} />

            <div className={"row mb-2 d-flex justify-content-between align-items-center flex-wrap"}>
                <div className={"d-inline-flex"}>
                    <Breadcrumbs hasTopMargin={false} navItems={navItems} />
                </div>
                <div className="d-flex justify-content-end align-items-center">
                    <OwPrintButton />
                </div>
            </div>

            {orders.map((order) => {
                return (
                    <div key={order.guid} className={"DocumentContainer"}>
                        <OrderCreateInvoiceView order={order} viewOptions={viewOptions} supplierModel={supplierModel} />

                        <div className={"row"}>
                            <div className={"col-12 justify-content-end d-flex"}>
                                <OrderTotalsPanel
                                    shouldHidePricingFn={() => {
                                        return false;
                                    }}
                                    shouldHideTaxJarName={true}
                                    order={order}
                                    orderItemType={"standard"}
                                    isReadOnly={true}
                                    lineView={true}
                                />
                            </div>
                        </div>

                        {supplierModel.invoice_footer ? <div className={"text-center"}>{supplierModel.invoice_footer}</div> : null}
                    </div>
                );
            })}

            {loaded && !orders.length ? (
                <div className={"text-center mt-4"}>
                    <FormattedMessage id="no_orders_found" defaultMessage="No Orders Found" description="No Orders Found" />
                </div>
            ) : null}
        </div>
    );
};
